export default __webpack_public_path__ + "static/media/02d.385c04a8.jpg";